import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'

import Img1 from './create_product.png'

function CertificateHelper(props) {

    const [showModal, setShowModal] = useState(false)

    return [
        <button
            key='1'
            onClick={() => setShowModal(true)}
            className='btn btn-outline-danger'
        >
            Precisa de ajuda?
        </button>,
        <Modal scrollable={true} centered size="lg" show={showModal}>
            <Modal.Header>
                <h4>Como cadastrar um produto</h4>
            </Modal.Header>
            <Modal.Body>
                <p>
                    Aqui você preenche as informações do seu produto:
                </p>
                <ul>
                    <li><strong>Código interno</strong>: é o código de referência do seu produto, e se você quiser, pode trocar esse código pela forma que melhor lhe atende;</li>
                    <li><strong>Unidade</strong>: é a medida de como você vende seu produto, ou seja, Un, KG, L, CX, etc, Se precisar, você pode adicionar mais tipo de unidade;</li>
                    <li><strong>Categoria</strong>: é o tipo de produto que você vende, podendo adicionar novas categorias para seus produtos. Aqui é interessante adicionar pelo menos uma categoria, para quando você for fazer relatório, você conseguir segmentar por tipo de produto vendido;</li>
                    <li><strong>NCM</strong>: é a Nomenclatura Comum do Mercosul. Se você não sabe o NCM do seu produto, você pode consultar em alguma nota fiscal de entrada, que está na nota fiscal do produto que você comprou pra revender. Ou pode acessar o link abaixo da caixa de texto, para acessar uma tabela com vários códigos de NCM;</li>
                    <li><strong>CFOP</strong>: é o Código Fiscal de Operações e de Prestações, e ele indica o tipo de operação que você faz. Os mais comum são os indicados na sessão de sugestão.</li>
                    <ul>
                        <li><strong>5101</strong>: é o código de mercadoria produzida. Um restaurante, por exemplo, que compra os insumos e produz seu próprio produto, estaria nessa categoria; </li>
                        <li><strong>5102</strong>: é o código de mercadoria adquirida. Um supermercado que compra os produtos e revende é um exemplo dessa categoria.</li>
                    </ul>
                    <li><strong>ICMS</strong>: para você que é MEI, empresa de pequeno ou médio porte, só precisa inserir o imposto ICMS. Clique em criar (pode colocar no nome Simples nacional), escolha se a origem da mercadoria é Nacional ou Estrangeira, e selecione o CSOSN (Código de Situação da Operação do  Simples Nacional).</li>
                    <ul>
                        <li>A maioria das empresas se enquadra no 102 (Tributada pelo Simples Nacional sem permissão de crédito), mas se você tiver dúvidas, recomendo que pergunte a um(a) contador(a).</li>
                    </ul>
                </ul>
                <p>Após o preenchimento, clique em <strong>Salvar</strong>. Se você não for redirecionado automaticamente, basta clicar em <strong>CLIENTES</strong> na barra lateral, depois em <strong>Novo</strong>.</p>
                <img className='col-12' src={Img1} />
            </Modal.Body>
            <Modal.Footer>
                <button onClick={() => setShowModal(false)} className="btn btn-primary">
                    Fechar
                </button>
            </Modal.Footer>
        </Modal>
    ]
}

export default CertificateHelper;


// WEBPACK FOOTER //
// ./src/components/tutorials/create_product/index.jsx